<template>
    <button class="rounded-full border border-white text-white text-center p-1 w-full">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'OutlineWhiteBtn',
};
</script>

<style lang="scss" scoped>
</style>
